import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const Tab = ({ currentTab, setCurrentTab, tabs }) => {
  return (
    <div>
      {
        tabs.map((t, i) => (
          <Tab.TabItem className={`${((i === 0 && !currentTab) || currentTab === t) ? 'selected' : ''}`} key={i} onClick={() => setCurrentTab(t)}>
            {t}
          </Tab.TabItem>
        ))
      }
    </div>
  );
};

Tab.propTypes = {
  currentTab: PropTypes.any,
  setCurrentTab: PropTypes.func.isRequired,
  tabs: PropTypes.array,
};

Tab.TabItem = styled.div`
  background-color: #e2e2ff
  margin-bottom: 5px;
  padding: 7px 10px;
  font-weight: normal;
  cursor: pointer;

  &.selected {
    color: white;
    background-color: #333fb8;
    position: relative;

    &:after {
      content: '';
      position: absolute;
      width: 0;
      height: 0;
      border: 12px solid #333fb8;
      left: calc(100% - 1px);
      top: 4px;
      border-top-color: transparent;
      border-right-color: transparent;
      border-bottom-color: transparent;
    }
  }
`;

export default Tab;
